import { render, staticRenderFns } from "./SupplyAndFollow.vue?vue&type=template&id=2eba3001&scoped=true"
import script from "./SupplyAndFollow.vue?vue&type=script&lang=js"
export * from "./SupplyAndFollow.vue?vue&type=script&lang=js"
import style0 from "./SupplyAndFollow.vue?vue&type=style&index=0&id=2eba3001&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eba3001",
  null
  
)

export default component.exports